import { useEffect, useState } from "react";

import StatsService from "@/services/statsService";

import GeneralSummarySection from "@/components/overview/generalSummarySection";
import StoreSummarySection from "@/components/overview/storeSummarySection";
import TablesSection from "@/components/overview/tablesSection";
import WarrantyChartSection from "@/components/overview/warrantyChartSection";

import useMerchantUserType from "@/hooks/useMerchantUserType";

const Overview = () => {
  const [generalStats, setGeneralStats] = useState(null);
  const [loading, setLoading] = useState(true);
  // Alt bayi merchant geneli rakamları görmemeli; kendi özetini görüyor
  // (bkz. StoreSummarySection). Kullanıcı tipi PrivateRoutes'taki checkAuth
  // tamamlanmadan bu sayfa mount olmuyor, dolayısıyla ilk render'da hazır.
  const { isStoreUser } = useMerchantUserType();

  useEffect(() => {
    if (isStoreUser) return;

    // Make a single API call to get general stats
    StatsService.getGeneralStats()
      .then((data) => {
        setGeneralStats(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [isStoreUser]);

  if (isStoreUser) {
    return (
      <main className="flex h-max min-h-full flex-col gap-12 bg-[#F9FAFC] p-4">
        <StoreSummarySection />
      </main>
    );
  }

  return (
    <main className="flex h-max min-h-full flex-col gap-12 bg-[#F9FAFC] p-4">
      <GeneralSummarySection data={generalStats} loading={loading} />
      <WarrantyChartSection />
      <TablesSection data={generalStats} loading={loading} />
    </main>
  );
};

export default Overview;
